// Shared by DeckSlopeViewCard and the pieces of its side elevations (SlopeSection and below).
export const GROUND_HATCH_ID = "deck-slope-ground-hatch";
export const GROUND_FILL_COLOR = "#e7d9bd";
export const GROUND_HATCH_COLOR = "#a9895a";
export const JOIST_COLOR = "#8a8f94";
export const BOARD_COLOR = "#b77b43";
export const DIMENSION_COLOR = "#0074d9";
export const TOTAL_HEIGHT_COLOR = "#1f2328";
export const LABEL_COLOR = "#333333";
export const WARNING_COLOR = "#c0392b";
// The run (L1/L2, in meters) is never drawn to scale against the height (in millimetres) - there's
// no single scale where both stay legible. But the two ground-clearance heights (h near vs h far)
// are both in the same unit, so those ARE drawn proportionally to each other: the larger one always
// reaches the frame's bottom edge (ratio 1), the other sits at its real fraction of that. A small
// floor keeps a sliver visible even when a height is at or below zero (slope exceeds what's left).
export const MIN_VISIBLE_HEIGHT_RATIO = 0.04;
export const JOIST_ICON_HEIGHT = 9;
export const BOARD_ICON_HEIGHT = 7;
